import React__default from 'react';

function SearchCtaIcon() {
    return (React__default.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React__default.createElement("path", { d: "M13.9999 14L11.0093 11.004M12.6666 7.00004C12.6666 8.50293 12.0696 9.94427 11.0069 11.007C9.94415 12.0697 8.50281 12.6667 6.99992 12.6667C5.49703 12.6667 4.05569 12.0697 2.99298 11.007C1.93027 9.94427 1.33325 8.50293 1.33325 7.00004C1.33325 5.49715 1.93027 4.05581 2.99298 2.9931C4.05569 1.9304 5.49703 1.33337 6.99992 1.33337C8.50281 1.33337 9.94415 1.9304 11.0069 2.9931C12.0696 4.05581 12.6666 5.49715 12.6666 7.00004V7.00004Z", stroke: "#151515", strokeWidth: "1.8", strokeLinecap: "round" })));
}

export { SearchCtaIcon as default };
//# sourceMappingURL=search-cta-icon.icon.js.map
